module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("cPzVc"))).then(() => parcelRequire('4J3kq'));